'use client';
import styles from './disclaimer.module.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@awesome.me/kit-012d1b9af0/icons/classic/solid';

import useModal from '@/components/modal/use-modal';
import Modal from '@/components/modal/modal';

export default function Disclaimer() {
	const { isOpen, onOpen, onClose } = useModal();

	return (
		<div className={styles.disclaimer}>
			<div className=''>
				<p className={styles.title}>
					<FontAwesomeIcon icon={faTriangleExclamation} color='#DD0000' size='lg' />{' '}
					Important
				</p>
			</div>

			<div className={styles.texts}>
				<p className={`${styles.text} ${styles.italic}`}>
					Scitrials.org does NOT endorse or recommend any study listed on this
					website.
				</p>

				<p className={styles.text}>
					All studies listed are experimental and may not have been evaluated by
					any Government body. Please read the disclaimer for details.
				</p>

				<p className={styles.text}>
					Before participating in a study, talk to your health care provider and
					learn about the risks and potential benefits.
				</p>
			</div>

			<button className={styles.btn} onClick={() => onOpen('disclaimer-modal')}>
				Disclaimer
			</button>

			<Modal
				isOpen={isOpen('disclaimer-modal')}
				onClose={() => onClose('disclaimer-modal')}
			>
				<Modal.Title>
					<div className={styles['dialog-title']}>Disclaimer</div>
				</Modal.Title>
				<Modal.Body>
					<div>
						<p className={styles['dialog-text']}>
							1. SciTrials.org has not evaluated any study on this site for
							safety or scientific validity.
						</p>
						<p className={styles['dialog-text']}>
							2. The safety and scientific validity of a study listed on
							SciTrials.org is the responsibility of the study sponsor and
							investigators.
						</p>
						<p className={styles['dialog-text']}>
							3. Before participating in a trial talk to your health care
							provider and learn about the risks and potential benefits.
						</p>
						<p className={styles['dialog-text']}>
							4. Clinical trials provide the basis for the development and
							marketing of new drugs, biological products, and medical devices.
							Sometimes, the safety and the effectiveness of the experimental
							approach or use may not be fully known at the time of the trial.
							Some trials may provide participants with the prospect of
							receiving direct medical benefits, while others do not. Most
							trials involve some risk of harm or injury to the participant,
							although it may not be greater than the risks related to routine
							medical care or disease progression.
						</p>
						<p className={styles['dialog-text']}>
							5. Many trials require participants to undergo additional
							procedures, tests, and assessments based on the study protocol.
							These requirements will be described in the informed consent
							document.
						</p>
						<p className={styles['dialog-text']}>
							6. A potential participant should also discuss these issues with
							members of the research team and with his or her usual health care
							provider.
						</p>
						<p className={styles['dialog-text']}>
							7. Please ensure you read all the documents in the "Learning About
							Clinical Trials" section on our homepage before participating in a
							study.
						</p>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						className={styles['dialog-btn']}
						onClick={() => onClose('disclaimer-modal')}
					>
						close
					</button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}
